export default ".img-preview {\n  max-width: 150px;\n}";